import { useTranslation } from "react-i18next";
import CheckIcon from "../../../icons/checkIcon";

const ShipRental = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className=" font-semibold text-[32px] text-center pb-10 ">
            {t("shipRental")}
          </h1>

          <p className=" text-[18px]">{t("weOfferInnovativeLogistics")} </p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/shipRental1.jpg"
            alt="ship rental 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/shipRental2.jpg"
            alt="ship rental 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/shipRental1.jpg"
            alt="ship rental 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/shipRental2.jpg"
            alt="ship rental 4"
          />
        </section>
        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("importanceOfShipLeasing")}
          </h2>
          <p>{t("shipLeasingService")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("importanceOfShipLeasing")}
          </h3>
          <p>{t("strategicLocation")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("roleOfShipCompanies")}
          </h3>
          <p>{t("shipManagementCompanies")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">{t("keyFactors")}</h3>
          <p>{t("operationsManagement")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("achievingHighEfficiency")}
          </h3>
          <p>{t("toEnsureOptimalEfficiency")}</p>
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("integratedSolutionsOperations")}
          </h3>
          <p>{t("megtlogisticsIsALeadingCompany")}</p>
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("megtlogisticsShipLeasing")}
          </h3>
          <div className="space-y-4">
            <section>
              <h4 className="text-lg text-mainBlue">{t("shipLeasingServices")}</h4>
              <p className="text-lg ">{t("diverseFleetVessels")}</p>
            </section>
            <section>
              <h4 className="text-lg text-mainBlue">{t("maritimeCrew")}</h4>
              <p className="text-lg ">{t("weRecognizeTheSuccess")}</p>
            </section>
            <section>
              <h4 className="text-lg text-mainBlue">{t("innovativeSolutions")} </h4>
              <p className="text-lg ">{t("shippingIndustryFacesMultiple")}</p>

              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("smartTrackingSystem")} </span>
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("predictiveMaintenance")}</span>
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("seamlessSupply")}</span>
              </p>
            </section>
          </div>
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("whyChoosemegtlogistics?")}
          </h3>
          <div className="space-y-4 text-lg">
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("extensiveExpertise")} </span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("customizedServices")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("adoptionOfModernTech")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("commitmentToInternationalSafety")}</span>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ShipRental;
